// import { motion } from "framer-motion";
// import {
//   ArrowRight,
//   Zap,
//   Share2,
//   Lock,
//   Smartphone,
//   Cpu,
//   Code,
// } from "lucide-react";

// export default function MobileAppPage() {
//   return (
//     <main style={{ backgroundColor: "#ffffff" }}>
//       {/* ================= HERO ================= */}

//       <section
//         style={{
//           background: `
//             linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)),
//             url('https://images.unsplash.com/photo-1498050108023-c5249f4df085?w=1920&q=80')
//           `,
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//         }}
//       >
//         <div
//           style={{
//             maxWidth: "1280px",
//             margin: "0 auto",
//             padding: "90px 20px",
//             color: "white",
//           }}
//         >
//           <motion.div
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.6 }}
//           >
//             <div
//               style={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: "16px",
//                 marginBottom: "20px",
//               }}
//             >
//               <div
//                 style={{
//                   background: "rgba(255,255,255,0.2)",
//                   padding: "14px",
//                   borderRadius: "8px",
//                 }}
//               >
//                 <Smartphone size={20} color="white" />
//               </div>
//               <span style={{ fontSize: "14px", fontWeight: 600 }}>
//                 MOBILE APPLICATION DEVELOPMENT
//               </span>
//             </div>

//             <h1
//               style={{
//                 fontSize: "48px",
//                 fontWeight: "bold",
//                 marginBottom: "20px",
//               }}
//             >
//               Enterprise-Grade Mobile Applications
//             </h1>

//             <p style={{ fontSize: "18px", maxWidth: "600px", opacity: 0.95 }}>
//               We design and build secure, scalable, and high-performance mobile
//               applications for iOS and Android platforms.
//             </p>
//           </motion.div>
//         </div>
//       </section>

//       {/* ================= iOS & ANDROID ================= */}
//       <section style={{ padding: "80px 20px" }}>
//         <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
//           <h2
//             style={{
//               fontSize: "34px",
//               fontWeight: "700",
//               marginBottom: "50px",
//               color: "#1a202c",
//               textAlign: "center",
//             }}
//           >
//             iOS & Android Expertise
//           </h2>

//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
//               gap: "30px",
//             }}
//           >
//             {[
//               {
//                 title: "iOS Application Development",
//                 desc: "High-performance iOS apps built using Swift and Apple’s modern frameworks.",
//                 points: [
//                   "Swift & Objective-C",
//                   "App Store Deployment",
//                   "Secure Payments & APIs",
//                 ],
//               },
//               {
//                 title: "Android Application Development",
//                 desc: "Robust Android applications optimized for speed, security, and scalability.",
//                 points: [
//                   "Kotlin & Java",
//                   "Google Play Publishing",
//                   "Firebase & Analytics",
//                 ],
//               },
//             ].map((item, idx) => (
//               <motion.div
//                 key={idx}
//                 whileHover={{ y: -4 }}
//                 style={{
//                   background: "#ffffff",
//                   padding: "32px",
//                   borderRadius: "12px",
//                   border: "1px solid #e2e8f0",
//                 }}
//               >
//                 <h3
//                   style={{
//                     fontSize: "22px",
//                     fontWeight: "700",
//                     color: "#4c51bf",
//                     marginBottom: "12px",
//                   }}
//                 >
//                   {item.title}
//                 </h3>

//                 <p style={{ color: "#4a5568", marginBottom: "16px" }}>
//                   {item.desc}
//                 </p>

//                 <ul style={{ paddingLeft: "18px", color: "#2d3748" }}>
//                   {item.points.map((p, i) => (
//                     <li key={i} style={{ marginBottom: "8px" }}>
//                       {p}
//                     </li>
//                   ))}
//                 </ul>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ================= FEATURES ================= */}
//       <section style={{ padding: "80px 20px", backgroundColor: "#f5f7fa" }}>
//         <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
//           <h2
//             style={{
//               fontSize: "34px",
//               fontWeight: "700",
//               marginBottom: "50px",
//               color: "#1a202c",
//               textAlign: "center",
//             }}
//           >
//             App Capabilities
//           </h2>

//           <div
//             style={{
//               display: "grid",
//               gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
//               gap: "30px",
//             }}
//           >
//             {[
//               {
//                 icon: Zap,
//                 title: "Real-Time Sync",
//                 desc: "Instant data synchronization across devices",
//               },
//               {
//                 icon: Lock,
//                 title: "Secure Authentication",
//                 desc: "Biometric & enterprise-grade security",
//               },
//               {
//                 icon: Share2,
//                 title: "Offline Access",
//                 desc: "Apps that work without internet",
//               },
//               {
//                 icon: Cpu,
//                 title: "Native Performance",
//                 desc: "Optimized for speed and reliability",
//               },
//             ].map((item, idx) => {
//               const Icon = item.icon;
//               return (
//                 <motion.div
//                   key={idx}
//                   whileHover={{ scale: 1.05 }}
//                   style={{
//                     background: "#ffffff",
//                     padding: "30px",
//                     borderRadius: "12px",
//                     textAlign: "center",
//                     boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
//                   }}
//                 >
//                   <div
//                     style={{
//                       width: "64px",
//                       height: "64px",
//                       margin: "0 auto 18px",
//                       borderRadius: "50%",
//                       background:
//                         "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                       display: "flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                     }}
//                   >
//                     <Icon size={28} color="white" />
//                   </div>
//                   <h3 style={{ fontSize: "18px", fontWeight: "700" }}>
//                     {item.title}
//                   </h3>
//                   <p style={{ color: "#4a5568" }}>{item.desc}</p>
//                 </motion.div>
//               );
//             })}
//           </div>
//         </div>
//       </section>

//       {/* ================= PROCESS ================= */}
//       <section style={{ padding: "80px 20px" }}>
//         <div style={{ maxWidth: "900px", margin: "0 auto" }}>
//           <h2
//             style={{
//               fontSize: "34px",
//               fontWeight: "700",
//               marginBottom: "50px",
//               color: "#1a202c",
//               textAlign: "center",
//             }}
//           >
//             Our Development Approach
//           </h2>

//           <div
//             style={{ display: "flex", flexDirection: "column", gap: "32px" }}
//           >
//             {[
//               {
//                 step: "1",
//                 title: "Planning & Strategy",
//                 desc: "Requirements analysis, architecture, and roadmap definition.",
//               },
//               {
//                 step: "2",
//                 title: "UI/UX Design",
//                 desc: "User-centric design focused on usability and clarity.",
//               },
//               {
//                 step: "3",
//                 title: "Development & Testing",
//                 desc: "Agile development with continuous testing.",
//               },
//               {
//                 step: "4",
//                 title: "Launch & Support",
//                 desc: "App store deployment and long-term maintenance.",
//               },
//             ].map((item, idx) => (
//               <motion.div
//                 key={idx}
//                 whileHover={{ y: -3 }}
//                 style={{
//                   display: "grid",
//                   gridTemplateColumns: "50px 1fr",
//                   gap: "20px",
//                   padding: "28px",
//                   borderRadius: "14px",
//                   background: "#ffffff",
//                   border: "1px solid #e2e8f0",
//                 }}
//               >
//                 <div
//                   style={{
//                     width: "50px",
//                     height: "50px",
//                     borderRadius: "50%",
//                     background:
//                       "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                     color: "white",
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     fontWeight: "700",
//                   }}
//                 >
//                   {item.step}
//                 </div>

//                 <div>
//                   <h3 style={{ fontSize: "20px", fontWeight: "700" }}>
//                     {item.title}
//                   </h3>
//                   <p style={{ color: "#4a5568" }}>{item.desc}</p>
//                 </div>
//               </motion.div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* ================= CTA ================= */}
//       <section
//         style={{
//           background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//           padding: "70px 20px",
//           color: "white",
//           textAlign: "center",
//         }}
//       >
//         <h2
//           style={{ fontSize: "34px", fontWeight: "700", marginBottom: "20px" }}
//         >
//           Build Your Mobile App With Us
//         </h2>
//         <p style={{ fontSize: "18px", marginBottom: "30px" }}>
//           From idea to App Store — we handle everything.
//         </p>

//         <a
//           href="/contact"
//           style={{
//             display: "inline-flex",
//             alignItems: "center",
//             gap: "10px",
//             background: "#ffffff",
//             color: "#667eea",
//             padding: "14px 30px",
//             borderRadius: "8px",
//             fontWeight: "600",
//             textDecoration: "none",
//           }}
//         >
//           Schedule Consultation <ArrowRight size={18} />
//         </a>
//       </section>
//     </main>
//   );
// }

import { motion } from "framer-motion";
import {
  ArrowRight,
  Zap,
  Lock,
  Smartphone,
  Cpu,
  CheckCircle2,
  Layers,
  Fingerprint,
  Activity,
  Cloud,
} from "lucide-react";
import { Link } from "react-router-dom";

const fadeUp = {
  initial: { opacity: 0, y: 20 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6 },
};

export default function MobileAppPage() {
  return (
    <main className="bg-white font-inter selection:bg-indigo-100">
      {/* ================= HERO SECTION ================= */}
      <section className="relative h-[400px] flex items-center overflow-hidden bg-[#0f172a]">
        {/* Professional BG with low opacity overlay */}
        <div
          className="absolute inset-0 bg-cover bg-center opacity-20 scale-105"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?auto=format&fit=crop&q=80&w=1600')",
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0f172a] via-[#0f172a]/95 to-transparent" />

        {/* Subtle Tech Grid overlay */}
        <div
          className="absolute inset-0 opacity-[0.1]"
          style={{
            backgroundImage: `radial-gradient(#4f46e5 0.5px, transparent 0.5px)`,
            backgroundSize: "30px 30px",
          }}
        />

        <div className="relative max-w-7xl mx-auto px-6 w-full text-left">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="max-w-2xl"
          >
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-indigo-500/10 border border-indigo-500/20 text-indigo-400 text-[10px] font-bold tracking-[0.3em] uppercase mb-6">
              Engineering Mobility
            </div>
            <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4 tracking-tight leading-tight">
              Enterprise <span className="text-indigo-400">Mobile</span>{" "}
              Ecosystems.
            </h1>
            <p className="text-base text-slate-300 text-white mb-8 leading-relaxed font-light">
              We architect secure, scalable, and native-performance mobile
              applications designed to drive user engagement and high-velocity
              business growth.
            </p>
            <div className="flex gap-3">
              <Link
                to="/contact"
                className="bg-indigo-600 text-white px-6 py-2.5 rounded-lg text-sm font-bold hover:bg-indigo-700 transition-all flex items-center gap-2 shadow-lg"
              >
                Request Strategy Session <ArrowRight size={16} />
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      {/* ================= PLATFORM EXPERTISE (REFINED GRID) ================= */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <span className="text-indigo-600 text-[11px] font-bold tracking-[0.2em] uppercase block mb-3">
              Native & Hybrid
            </span>
            <h2 className="text-3xl font-bold text-slate-900 tracking-tight">
              Multi-Platform Mastery
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            {[
              {
                title: "iOS Development",
                desc: "High-precision applications built for the Apple ecosystem using Swift and modern UI frameworks.",
                points: [
                  "Swift & SwiftUI Architecture",
                  "Apple Pay & Biometric Security",
                  "Native Performance Optimization",
                ],
              },
              {
                title: "Android Development",
                desc: "Robust, scalable Android solutions optimized for a diverse device landscape using Kotlin.",
                points: [
                  "Kotlin & Material Design",
                  "Cloud Messaging Integration",
                  "Hardware Level APIs",
                ],
              },
            ].map((item, idx) => (
              <motion.div
                key={idx}
                {...fadeUp}
                className="group p-8 rounded-2xl border border-slate-200 bg-white hover:border-indigo-500/30 transition-all duration-300 shadow-sm hover:shadow-xl"
              >
                <h3 className="text-xl font-bold text-slate-900 mb-4 group-hover:text-indigo-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-slate-500 mb-6 font-light leading-relaxed">
                  {item.desc}
                </p>
                <ul className="space-y-3">
                  {item.points.map((point, i) => (
                    <li
                      key={i}
                      className="flex items-center gap-2 text-xs font-semibold text-slate-700"
                    >
                      <CheckCircle2 size={16} className="text-indigo-600" />{" "}
                      {point}
                    </li>
                  ))}
                </ul>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= APP CAPABILITIES (INDUSTRIAL STYLE) ================= */}
      <section className="py-24 bg-slate-50 border-y border-slate-100">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-20">
            <h2 className="text-3xl font-bold text-slate-900 tracking-tight">
              Core Technical Capabilities
            </h2>
            <p className="text-slate-500 mt-4 max-w-xl mx-auto font-light">
              Engineered for absolute performance and enterprise-grade security.
            </p>
          </div>

          <div className="grid md:grid-cols-4 gap-6">
            {[
              {
                icon: Zap,
                title: "Real-Time Sync",
                desc: "Instant data orchestration across multiple digital touchpoints.",
              },
              {
                icon: Lock,
                title: "Cyber Resilience",
                desc: "Enterprise-grade encryption and biometric authentication layers.",
              },
              {
                icon: Activity,
                title: "Native Perf",
                desc: "Optimized bytecode execution for seamless 60FPS user experiences.",
              },
              {
                icon: Cloud,
                title: "Edge Integration",
                desc: "Direct connectivity with AWS, Azure, and private cloud infrastructures.",
              },
            ].map((f, i) => (
              <motion.div
                key={i}
                {...fadeUp}
                transition={{ delay: i * 0.1 }}
                className="bg-white p-8 rounded-2xl border border-slate-200 hover:border-indigo-500/30 transition-all group shadow-sm"
              >
                <div className="w-10 h-10 bg-slate-50 flex items-center justify-center rounded-xl text-slate-900 group-hover:bg-indigo-600 group-hover:text-white transition-all mb-6">
                  <f.icon size={20} />
                </div>
                <h3 className="font-bold text-slate-900 mb-3 tracking-tight group-hover:text-indigo-600 transition-colors">
                  {f.title}
                </h3>
                <p className="text-[13px] text-slate-500 leading-relaxed font-light">
                  {f.desc}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ================= TECH STACK SECTION (NEW CONTENT) ================= */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="bg-[#0f172a] rounded-3xl p-10 md:p-16 relative overflow-hidden">
            <div className="absolute top-0 right-0 w-64 h-64 bg-indigo-600/10 blur-[100px] rounded-full" />

            <div className="relative z-10 grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-3xl font-bold text-white mb-6">
                  Modern Mobility Stack
                </h2>
                <p className="text-slate-400 mb-8 font-light leading-relaxed">
                  Our engineering team leverages world-class technologies to
                  build future-proof mobile applications that scale with your
                  users.
                </p>
                <div className="grid grid-cols-2 gap-4">
                  {[
                    "Swift / SwiftUI",
                    "Kotlin / Compose",
                    "Flutter / React Native",
                    "Node.js Backend",
                    "Firebase / GraphQL",
                    "AWS / Azure Mobile",
                  ].map((tech) => (
                    <div
                      key={tech}
                      className="flex items-center gap-3 bg-white/5 border border-white/10 p-3 rounded-xl"
                    >
                      <CheckCircle2 size={16} className="text-indigo-400" />
                      <span className="text-[13px] text-slate-300 font-medium">
                        {tech}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="hidden lg:block relative">
                <div className="absolute inset-0 bg-indigo-500/20 blur-[80px] rounded-full" />
                <Smartphone
                  size={300}
                  className="mx-auto text-white opacity-20 rotate-12"
                  strokeWidth={0.5}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= FINAL CTA ================= */}
      <section className="py-24 bg-[#0f172a] relative overflow-hidden">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[300px] bg-indigo-500/10 rounded-full blur-[120px]" />

        <div className="relative z-10 max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 tracking-tight">
            Architect Your Mobile Future.
          </h2>
          <p className="text-slate-400 mb-10 text-lg font-light leading-relaxed max-w-2xl mx-auto">
            Ready to deploy an enterprise-grade mobile solution? Let’s map out
            your technical requirements and build a high-performance roadmap.
          </p>
          <div className="flex justify-center">
            <Link
              to="/contact"
              className="bg-white text-slate-900 px-8 py-2.5 rounded-lg text-sm font-bold hover:bg-indigo-50 transition-all shadow-xl"
            >
              Initiate Technical Consultation
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}